export const tituloPrincipal = "Categorias de Suporte";


export const conta = "Conta"
export const descricaoConta = "Gerencie suas informações pessoais, senha e segurança.";


export const problemas = "Problemas Técnicos"
export const descricaoProblemas = "Solucione erros de login, travamentos ou bugs."


export const pagamentos = "Pagamentos"
export const descricaoPagamentos = "Informações sobre cobranças, reembolsos e faturas.";


export const seguranca = "Segurança"
export const descricaoSeguranca = "Dicas para manter sua conta protegida e segura.";


export const notificacoes = "Notificações"
export const descricaoNotificacoes = "Gerencie preferências de e-mail e push.";


export const privacidade = "Privacidade"
export const descricaoPrivacidade = "Controle o uso dos seus dados pessoais.";


export const atualizacoes = "Atualizações"
export const descricaoAtualizacoes = "Saiba mais sobre as últimas novidades e mudanças.";